module.exports = __webpack_public_path__ + "static/media/NYT_bw.c27d9a29.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/press/NYT_bw.png
 ** module id = 2420
 ** module chunks = 44
 **/